export default "__VITE_ASSET__tUXBtnGP__"